import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { debounce } from "./debounce"
import { setWindowSize } from "../store/handlingSlice"

export const UpdateSize = () => {
  const dispatch = useDispatch()
  const lag = 300

  const updateDimensions = (event) => {
    let vh = event.target.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", vh + "px")
    let size = {
      width: event.target.innerWidth,
      height: event.target.innerHeight,
    }

    return dispatch(setWindowSize(size))
  }

  const setDimensions = () => {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", vh + "px")

    let size = {
      width: window.innerWidth,
      height: window.innerHeight,
    }

    return dispatch(setWindowSize(size))
  }

  const throttleUpdate = debounce(updateDimensions, lag)

  useEffect(() => {
    window.addEventListener("resize", throttleUpdate)
    setDimensions()
    return () => window.removeEventListener("resize", throttleUpdate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
